/**
 * @export
 * @enum {string}
 * This enum is a collection of all browser local storage names
 */
export enum StorageEnum {
  AddShiftieToHome = 'addShiftieToHome',
  ApiVersion = 'apiVersion',
  CompanyId = 'companyId',
  DeviceId = 'deviceId',
  FromRoute = 'fromRoute',
  Info = 'info',
  LastChunkReload = 'lastChunkReload',
  OfferCode = 'offerCode',
  OnboardingClosed = 'onboardingClosed',
  ScheduleFilter = 'shiftieScheduleFilter',
  ScheduleViewOptions = 'scheduleViewOptions',
  ScheduleGroupToggles = 'scheduleGroupToggles',
  ScheduleOverviewFilter = 'scheduleOverviewFilter',
  ShowTips = 'showTips',
  TeamFilter = 'shiftieTeamFilter',
  TimesheetFilter = 'shiftieTimesheetFilter',
  Version = 'version',
}
